import 'magnific-popup';

export default $(()=>{
    // $('.open-popup-link').magnificPopup({
    //     type:'inline',
    //     midClick: true,
    //     mainClass: 'custom-popup-class'
    // });

    if ($('#redirectModal').length) {
    	$.magnificPopup.open({
		    items: {
		        src: '#redirectModal' 
		    },
		    type: 'inline',
            showCloseBtn: false,
            closeBtnInside: true,
            mainClass: 'modalFrame',
            showCloseBtn: false,
            closeBtnInside: true,
		});
        $('#redirectModal a.close').click(function(){            
            $.magnificPopup.close();
        });
    }

    if ($('.price-sheets-modal').length) {
        $('.price-sheets-modal').magnificPopup({
            type:'inline',
            midClick: true,
        });
    }

    $('.inline-modal a.download').click(function(){
         $.magnificPopup.close();
    });
}); 